export default __webpack_public_path__ + "607923ffe6f8676f2c18e235904ba058.png";